<template>
  <qc-dialog class="tc-15-rich-dialog cos" type="custom" :show="innerShow" :title="$t('core.share_file_or_folder')"
    :default-cancel="false" @close="closeDialog" :width="500">
    <ul class="item-descr-list allow-user-select">

      <li>
        <span class="item-descr-tit">
          <label>URL</label>
        </span>
        <span class="item-descr-txt width-82percent">
          <qc-input v-model="url" type="textarea" :rows="4" :readonly="true"
            style="line-height:16px;background-color:unset;padding:8px;"></qc-input>
        </span>
      </li>

      <li>
        <span class="item-descr-tit">
          <label>{{$t('core.extract_code')}}</label>
        </span>
        <span class="item-descr-txt">
          <qc-input readonly v-model="extract" style="width:80px;background-color:unset;"></qc-input>
        </span>
      </li>

      <li>
        <span class="item-descr-tit">
          <label>{{$t('core.expire_time')}}</label>
        </span>
        <span class="item-descr-txt">
          {{expire | DateStr}}
        </span>
      </li>

    </ul>

    <div slot="button">
      <div class="justify-grid">
        <div class="col"></div>
        <div class="col">
          <qc-button type="default" @click="copy" :title="$t('core.copy')">
            {{$t('core.copy')}}</qc-button>
          <qc-button type="weak" @click="closeDialog" :title="$t('core.close')">{{$t('core.close')}}</qc-button>
        </div>
      </div>
    </div>

  </qc-dialog>

</template>

<script>
import { tips, getInnerProps, copyText2Clipboard } from '@/scripts/tools/utils';

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
      default: true,
    },
    shareMultipleInfo: Object,
  },
  computed: {
    innerShow: getInnerProps('show'),
    url() {
      return this.shareMultipleInfo.url || '';
    },
    extract() {
      return this.shareMultipleInfo.extract || '';
    },
    expire() {
      return this.shareMultipleInfo.expire * 1000;
    },
  },
  methods: {
    copy() {
      // TODO: 翻译文字
      const text = `链接：${this.url}  提取码：${this.extract}`;
      copyText2Clipboard(text, true);
      tips.success('已成功复制链接和提取码！');
    },
    closeDialog() {
      this.innerShow = false;
    },
  },
};
</script>

<style scoped lang="scss">
.width-82percent {
  width: 82%;
  input {
    width: 100%;
  }
}
</style>
